import { render, staticRenderFns } from "./AccountSettingPaymentData.vue?vue&type=template&id=06c8f9f8&scoped=true&"
import script from "./AccountSettingPaymentData.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPaymentData.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingPaymentData.vue?vue&type=style&index=0&id=06c8f9f8&scoped=true&lang=css&"
import style1 from "./AccountSettingPaymentData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8f9f8",
  null
  
)

export default component.exports